import Giraffe from './Giraffe';

function App() {
  return (
    <div className="App">
      <Giraffe />
    </div>
  );
}

export default App;
